import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "classroom-closed.title",
    },
    again: {
        id: "classroom-closed.again",
    },
});

export default messages;
